import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { AccessTokensStore } from 'pages/settings/pages/developer/pages/accessTokens/store/accessTokensStore'

export const AccessTokensViewContext = createContext<AccessTokensStore | null>(null)

export const useAccessTokensViewContext = () => {
  const context = useContext(AccessTokensViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AccessTokensViewContext')

  return context
}

export const AccessTokensViewProvider = ({ children }: PropsWithChildren) => {
  const store = useMemo(() => new AccessTokensStore(), [])

  useEffect(() => {
    void store.init()
    return () => store.dispose()
  }, [store])

  return (
    <AccessTokensViewContext.Provider value={store}>{children}</AccessTokensViewContext.Provider>
  )
}
